module.exports = __webpack_public_path__ + "img/ellipsis-vertical-circle-outline.3259d2ea.svg";